import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Address } from '../../api/models/address';
import { MarketService } from '../../api/services/market.service';
import { PreferencesService } from '../../api/services/preferences.service';
import { AuthService } from '../../api/services/auth.service';
import { Subject } from 'rxjs';
import { StateAbbreviation } from '../../api/models/market-model';

@Component({
  selector: 'app-address-creation',
  templateUrl: './address-creation.component.html',
  styleUrls: ['./address-creation.component.scss']
})
export class AddressCreationComponent implements OnInit {

  @Input() flag: Boolean;

  @Input()
  set addressName(name: string) {
    this.newAddress.locationName = name;
  }

  newAddressForm: FormGroup;
  newAddress = new Address();
  marketId: string;
  parcel = false;
  bulk = false;
  requiresLift = false;
  err: any;
  addressNameError = false;
  errorMessages$: Subject<string[]> = new Subject();
  states: StateAbbreviation[] = [];

  constructor(public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private marketservice: MarketService,
    private preferencesService: PreferencesService,
    private authService: AuthService
  ) {
  }

  onSubmit() {
    this.newAddress = this.newAddressForm.value;
    this.newAddress.requiresLiftGate = this.requiresLift;
    this.newAddress.acceptBulk = this.bulk;
    this.newAddress.acceptParcel = this.parcel;
    this.marketservice.saveAddress(this.marketId, this.newAddress).subscribe(address => {
      this.activeModal.close(address);
      if(this.flag) {
        document.body.classList.add('modal-open');
      }
    }, error => {
          this.errorMessages$.next([error.error.message]);
        });
}

  ngOnInit() {
    this.marketservice.getStateAbbreviations().subscribe(response => {
      this.states = response;
    });
    this.newAddressForm = this.formBuilder.group({
      locationName: [this.newAddress.locationName, Validators.required],
      city: [this.newAddress.city, Validators.required],
      companyName: [this.newAddress.companyName, Validators.required],
      locationCode: [this.newAddress.locationCode],
      contactName: [this.newAddress.contactName],
      contactPhone: [this.newAddress.contactPhone],
      line1: [this.newAddress.line1, Validators.required],
      line2: [this.newAddress.line2],
      line3: [this.newAddress.line3],
      state: [this.newAddress.state, Validators.required],
      zip: [this.newAddress.zip, Validators.required]
    });
    this.preferencesService.getPreferences('USER', this.authService.getUserId())
      .subscribe(prefs => {
        this.marketId = prefs['current-market'].Value;
      });
  }

  get locationName() { return this.newAddressForm.get('locationName'); }
  get companyName() { return this.newAddressForm.get('companyName'); }
  get line1() { return this.newAddressForm.get('line1'); }
  get state() { return this.newAddressForm.get('state'); }
  get zip() { return this.newAddressForm.get('zip'); }
  get city() { return this.newAddressForm.get('city'); }

  nonSpecifiedType() {
    return !(this.bulk || this.parcel);
  }

  closeAddress() : void {
    this.activeModal.dismiss();
    if(this.flag){
      document.body.classList.add('modal-open');
    }
  }

  closeErrorMessage() {
    this.errorMessages$.next(undefined);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/address-creation/address-creation.component.ts